const FOCUSABLE_ELEMENTS = ['a:not([tabindex^="-"]):not([inert])', 'button:not([disabled]):not([inert])', 'global-header-search-block', 'label'].join(',');
import IconClose from '../components/icon/close.vue';
import IconChevron from '../components/icon/chevron.vue';
import { customEventTrigger } from '../lib/customGoogleEvents';
export default {
  components: {
    IconClose,
    IconChevron
  },
  props: {
    popoverId: {
      type: String,
      default: undefined
    },
    popoverName: {
      type: String,
      default: ''
    },
    rightAlignment: {
      type: Boolean,
      default: false
    },
    customClassContainer: {
      type: String,
      default: undefined
    },
    customClassTrigger: {
      type: String,
      default: undefined
    },
    customClassContent: {
      type: String,
      default: undefined
    },
    width: {
      type: Number,
      default: 320
    },
    minWidth: {
      type: Number,
      default: 320
    },
    fixedSize: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const vm = this;
    return {
      popoverLeftPosition: '0',
      popoverRightPosition: '0',
      popoverTopPosition: '0',
      popoverWidth: vm.width,
      popoverMinWidth: vm.minWidth,
      focusable: [],
      lastFocusedElement: null,
      active: false
    };
  },
  mounted: function () {
    window.addEventListener('click', this.closePopover);
    window.addEventListener('keydown', this.handleKeyboard);
    window.addEventListener('resize', this.calculatePopoverPosition);
  },
  destroyed: function () {
    window.removeEventListener('click', this.closePopover);
    window.removeEventListener('keydown', this.handleKeyboard);
    window.removeEventListener('resize', this.calculatePopoverPosition);
  },
  updated: function () {
    this.calculatePopoverPosition();
  },
  methods: {
    toggleActivePopover: function () {
      const newState = !this.active;
      // trigger on timeout so propagation of click event will not automatically disable popup
      setTimeout(() => {
        this.active = newState;
        if (this.popoverId === undefined || this.popoverId === null) {
          return;
        } else if (this.popoverId === this.activePopoverId) {
          this.$emit('popover-expanded', false);
          // this.$store.commit('popover/closeActivePopover');
          this.$emit('close');
        } else {
          this.lastFocusedElement = document ? document.activeElement : null;
          this.$emit('popover-expanded', true);
          // this.$store.commit('popover/setActivePopoverId', this.popoverId);

          this.$nextTick(() => {
            this.$nextTick(() => {
              this.setInitialFocus();
            });
          });
        }
      }, 1);
    },
    closePopover: function () {
      this.active = false;
      if (this.popoverId === this.activePopoverId) {
        this.$emit('popover-expanded', false);
        // this.$store.commit('popover/closeActivePopover');
        this.$emit('close');
        if (this.lastFocusedElement) {
          this.lastFocusedElement.focus();
        }
      }
    },
    runInitialFocus() {
      // set focus from parent component
      this.lastFocusedElement = document ? document.activeElement : null;
      this.setInitialFocus();
    },
    getShadowRoot() {
      const globalHeaderWebComponent = document.getElementsByTagName('global-header')[0].shadowRoot;
      return globalHeaderWebComponent;
    },
    getFocusableChildren() {
      const shadowRoot = this.getShadowRoot();
      const globalHeader = shadowRoot.children[shadowRoot.DOCUMENT_FRAGMENT_NODE - 1];
      const popoverContent = globalHeader.getElementsByClassName(`gh-popoverContainer-${this.popoverName}`)[0].getElementsByClassName('gh-popoverContent')[0];
      if (!popoverContent) {
        return [];
      }
      const topElements = Array.from(popoverContent.querySelectorAll(FOCUSABLE_ELEMENTS));
      const shadowElements = topElements.filter(x => x.shadowRoot).flatMap(x => x.shadowRoot.querySelectorAll(FOCUSABLE_ELEMENTS) || [])[0] || [];
      this.focusable = [...topElements, ...shadowElements];
    },
    setInitialFocus() {
      this.getFocusableChildren();
      this.focusable[0].focus();
    },
    handleKeyboard: function (e) {
      if (this.popoverId === this.activePopoverId && e.keyCode === 27) {
        this.closePopover();
      }
      if (this.popoverId === this.activePopoverId && (e.key === 'Tab' || e.keyCode === 9)) {
        this.trapFocus(e);
      }
    },
    trapFocus: function (e) {
      this.getFocusableChildren();
      let firstFocusable = this.focusable[0];
      let lastFocusable = this.focusable[this.focusable.length - 1];
      const shadowRoot = this.getShadowRoot();
      const activeElements = [document.activeElement];
      if (shadowRoot) activeElements.push(shadowRoot.activeElement);
      if (shadowRoot && shadowRoot.activeElement && shadowRoot.activeElement.shadowRoot) activeElements.push(shadowRoot.activeElement.shadowRoot.activeElement);
      if (e.shiftKey) {
        if (activeElements.includes(firstFocusable)) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        if (activeElements.includes(lastFocusable)) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    },
    calculatePopoverPosition: function () {
      const popoverContent = this.$refs.ghPopoverContent;
      const popoverContainer = this.$refs.popoverContainer;
      if (popoverContent && popoverContainer) {
        const parentHeight = popoverContainer.clientHeight;
        const parentWidth = popoverContainer.clientWidth;
        const parentLeftOffset = popoverContainer.offsetLeft;
        const windowWidth = window.innerWidth;
        const avaiableTooltipSpace = windowWidth - parentLeftOffset;
        this.popoverTopPosition = parentHeight;
        if (avaiableTooltipSpace <= this.minWidth && this.fixedSize) {
          this.popoverLeftPosition = 'auto';
          return;
        }
        if (windowWidth < this.popoverMinWidth) {
          this.popoverMinWidth = windowWidth;
          this.popoverWidth = windowWidth;
        }
        if (windowWidth < 420 && !this.fixedSize) {
          this.popoverMinWidth = 'auto';
          this.popoverWidth = windowWidth - 48;
          if (parentLeftOffset > 16) {
            this.popoverLeftPosition = `-${parentLeftOffset}`;
          }
        } else if (this.rightAlignment) {
          this.popoverLeftPosition = 'auto';
          const availableSpace = parentLeftOffset + parentWidth;
          if (this.popoverWidth > availableSpace) {
            this.popoverRightPosition = availableSpace - this.popoverWidth;
          } else {
            this.popoverRightPosition = 0;
          }
        } else {
          const popoverRightCornerOffsetArea = parentLeftOffset + this.width + 24;
          if (popoverRightCornerOffsetArea > windowWidth) {
            this.popoverLeftPosition = popoverRightCornerOffsetArea - windowWidth > parentLeftOffset ? '0' : `${windowWidth - popoverRightCornerOffsetArea}`;
          } else {
            this.popoverLeftPosition = '0';
          }
        }
      }
    },
    insidePopoverClick(e) {
      customEventTrigger(e);
    }
  }
};